import * as actionTypes from "../constants/actionTypes";
import * as methods from "../constants/methods";
import * as getActions from "./getActions";
import * as orderStatus from "../constants/orderStatus";
import * as componentTypes from "../constants/componentTypes";
import * as handlers from "../constants/handlers";

export const setActiveDatabase = (tabId, database) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_SET_ACTIVE_DATABASE,
        params: {
            name: database.name,
            autologin: true
        }
    },
    method: handlers.INTERGAMMA_SET_ACTIVE_DATABASE,
    tabId: tabId
});

export const setDatabaseAndOpenFandeckStep = (tabId, database) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_SET_ACTIVE_DATABASE,
        params: {
            name: database.name,
            autologin: true
        }
    },
    method: handlers.INTERGAMMA_SET_DATABASE_AND_OPEN_FANDECK_STEP,
    tabId: tabId
});

export const sendOrder = (
    tabId,
    product,
    fandeck,
    color,
    formula,
    base,
    packageItem,
    customer,
    packageCount,
    databaseName,
    receiver,
    customNote
) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_ADD_ORDER_RECORD,
        params: {
            productId: product.id,
            fandeckId: fandeck.id,
            fandeckLocal: color.local,
            colorId: color.id,
            colorLocal: color.local,
            formulaId: formula.id,
            formulaLocal: color.local,
            baseId: base.id,
            formulaColorants: formula.getRealColorantAmounts(),
            scaling: formula.scaling,
            customerId: customer !== null ? customer.id : null,
            packageCount: packageCount,
            packageId: packageItem.id,
            customPackage: false,
            brand: databaseName,
            receiver: receiver,
            moreInfo: customNote,
            orderRecordType: formula.getStatsType()
        }
    },
    method: handlers.ADD_ORDER_RECORD,
    tabId: tabId
});

export const sendOrderByBarcode = (tabId, formula, barcode, receiver) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_ADD_ORDER_RECORD_BY_ORDER_BARCODE,
        params: {
            orderBarcode: barcode,
            receiver: receiver,
            orderRecordType: formula.getStatsType()
        }
    },
    method: handlers.ADD_ORDER_RECORD,
    tabId: tabId
});

export const sendOrderByHistoryBarcode = (tabId, formula, barcode, receiver) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_ADD_ORDER_RECORD_BY_HISTORY_BARCODE,
        params: {
            historicOrderBarcode: barcode,
            receiver: receiver,
            orderRecordType: formula.getStatsType()
        }
    },
    method: handlers.ADD_ORDER_RECORD,
    tabId: tabId
});

export const warningSelectCustomer = (
    tabId,
    product,
    fandeck,
    color,
    formula,
    base,
    packageItem,
    customer,
    packageCount,
    databaseName,
    receiver,
    customNote,
    barcode
) => ({
    type: actionTypes.NAVIGATION_OPEN_MODAL,
    payload: {
        tabId: tabId,
        type: componentTypes.INTERGAMMA_WARNING_CUSTOMER_MODAL,
        params: {
            product: product,
            fandeck: fandeck,
            color: color,
            formula: formula,
            base: base,
            packageItem: packageItem,
            customer: customer,
            packageCount: packageCount,
            databaseName: databaseName,
            receiver: receiver,
            customNote: customNote,
            barcode: barcode
        }
    }
});

export const warningMissingData = (
    tabId,
    product,
    fandeck,
    color,
    formula,
    base,
    packageItem,
    customer,
    packageCount,
    databaseName,
    receiver,
    customNote,
    barcode
) => ({
    type: actionTypes.NAVIGATION_OPEN_MODAL,
    payload: {
        tabId: tabId,
        type: componentTypes.INTERGAMMA_WARNING_MISSING_DATA_MODAL,
        params: {
            product: product,
            fandeck: fandeck,
            color: color,
            formula: formula,
            base: base,
            packageItem: packageItem,
            customer: customer,
            packageCount: packageCount,
            databaseName: databaseName,
            receiver: receiver,
            customNote: customNote,
            barcode: barcode
        }
    }
});

export const selectDatabase = (activeDatabase, database) => ({
    type: actionTypes.INTERGAMMA_SELECT_DATABASE,
    payload: {
        activeDatabase: activeDatabase,
        database: database
    }
});

export const reloadFilteredColorList = (fandeck, colorName, rowCount, offset, fts) => {
    return getActions.getColorsByParams(
        0,
        null,
        fandeck === null ? null : fandeck.id,
        null,
        colorName,
        colorName,
        false,
        fts,
        false,
        true,
        handlers.INTERGAMMA_RELOAD_COLORS,
        rowCount,
        offset
    );
};

export const reloadFandeckList = (color, rowCount, offset, fts) => {
    return getActions.getFandecksByParams(
        0,
        null,
        color === null ? null : color.id,
        null,
        null,
        false,
        fts,
        false,
        true,
        handlers.INTERGAMMA_RELOAD_FANDECKS,
        rowCount,
        offset
    );
};

export const reloadFilteredFandeckList = (color, fandeckName, rowCount, offset, fts) => {
    return getActions.getFandecksByParams(
        0,
        null,
        color === null ? null : color.id,
        null,
        fandeckName,
        false,
        fts,
        false,
        true,
        handlers.INTERGAMMA_RELOAD_FANDECKS,
        rowCount,
        offset
    );
};

export const selectPackage = (selectedPackage) => ({
    type: actionTypes.INTERGAMMA_SELECT_PACKAGE,
    payload: {
        package: selectedPackage
    }
});

export const saveCustomNote = (note) => ({
    type: actionTypes.INTERGAMMA_SAVE_CUSTOM_NOTE,
    payload: {
        note: note
    }
});

export const resetProduct = () => ({
    type: actionTypes.INTERGAMMA_RESET_PRODUCT
});

export const resetColor = () => ({
    type: actionTypes.INTERGAMMA_RESET_COLOR
});

export const resetColorWithFandeck = () => ({
    type: actionTypes.INTERGAMMA_RESET_COLOR_WITH_FANDECK
});

export const resetFandeck = () => ({
    type: actionTypes.INTERGAMMA_RESET_FANDECK
});

export const resetFandeckWithColor = () => ({
    type: actionTypes.INTERGAMMA_RESET_FANDECK_WITH_COLOR
});

export const resetPackage = () => ({
    type: actionTypes.INTERGAMMA_RESET_PACKAGE
});

export const resetNote = () => ({
    type: actionTypes.INTERGAMMA_RESET_NOTE
});

export const changeNumberOfPackages = (numberOfPackages) => ({
    type: actionTypes.INTERGAMMA_CHANGE_NUMBER_OF_PACKAGES,
    payload: {
        numberOfPackages: numberOfPackages
    }
});

export const getCustomers = () => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_GET_ALL_CUSTOMERS
    },
    method: handlers.INTERGAMMA_GET_ALL_CUSTOMERS,
    tabId: 0
});

export const filterDate = (from, to) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_MY_ORDERS_GET_DATA,
        params: {
            dateFrom: from,
            dateTo: to,
            offset: 0,
            rowCount: null,
            statusFilter: orderStatus.MY_ORDER_STATUS_LIST
        }
    },
    method: handlers.MY_ORDERS_GET_DATA,
    tabId: 0
});

export const filterCustomers = (customer) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_MY_ORDERS_GET_DATA,
        params: {
            customer: customer,
            statusFilter: [1, 2, 3, 4, 5, 6]
        }
    },
    method: handlers.MY_ORDERS_GET_DATA,
    tabId: 0
});

export const filterDateAndCustomer = (from, to, customer) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_MY_ORDERS_GET_DATA,
        params: {
            customer: customer,
            dateFrom: from,
            dateTo: to,
            offset: 0,
            rowCount: null,
            statusFilter: orderStatus.MY_ORDER_STATUS_LIST
        }
    },
    method: handlers.MY_ORDERS_GET_DATA,
    tabId: 0
});

export const loadHistoryOrder = (qrCode) => ({
    type: actionTypes.INTERGAMMA_LOAD_HISTORY_ORDER,
    payload: {
        qrCode: qrCode
    }
});

export const changeDate = (from, to) => ({
    type: actionTypes.INTERGAMMA_CHANGE_DATE_FILTER,
    payload: {
        from: from,
        to: to
    }
});

export const setLastCustomer = (customer) => ({
    type: actionTypes.INTERGAMMA_SET_LAST_CUSTOMER,
    payload: {
        customer: customer
    }
});

export const resetLastCustomer = () => ({
    type: actionTypes.INTERGAMMA_RESET_LAST_CUSTOMER
});

export const saveOrderBarcode = (barcode) => ({
    type: actionTypes.INTERGAMMA_SAVE_ORDER_BARCODE,
    payload: {
        barcode: barcode
    }
});

export const resetOrderBarcode = () => ({
    type: actionTypes.INTERGAMMA_RESET_ORDER_BARCODE
});
